/** @module SourcingOrders/Orders */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/core/Key",
	"csi/reflection",
	"csi/table/Widget",
	"SourcingOrders"
], function(declare, _, Key, reflection, Widget, SourcingOrders) {

	return declare(Widget, {
		/** @property {Relationship} _poRelationship - relationship to show all of PO's orders */
		_poRelationship: null,

		/** @property {Relationship} _productRelationship - relationship to show orders of selected PurchasedOrderProduct */
		_productRelationship: null,

		/** @property {string} _urlPO - PurchasedOrder url, which may or may not be the current root node of the view (it is the original root node of the view) */
		_urlPO: null,

		/**
		 * Return PurchasedOrder node
		 * @return {C8Node}
		 */
		getPO() {
			return this.cacheView.get(this._urlPO);
		},

		/**
		 * Return true if the root node of the view is the PO
		 * @return {boolean}
		 */
		isPO() {
			return !this._urlPO || (this._urlPO == this.urlRoot);
		},

		onAccessActionUpdateOrdersBaseFOB: function(/*Context*/ctx, /*Action*/action) {
			const po = this.getPO();
			if (po.OrdersByColor && po.ShipmentTerms.length > 0) {
				return false;
			}
			var state = SourcingOrders.getPOState(po);
			return state == SourcingOrders.poStateDraft || state == SourcingOrders.poStateNegotiation;
		},

		onAccessActionUpdatesOrdersSizes: function(/*Context*/ctx, /*Action*/action) {
			var po = this.getPO();
			return (po.OrdersByColor && SourcingOrders.getPOState(po) == SourcingOrders.poStateDraft);
		},

		/**
		 * @override
		 * Determine if UnitPerPack and size matrix should be displayed based on current root node
		 */
		onViewResolveKeysToSkip(skipSet) {
			if (this.isPO()) {
				skipSet.add(Key.untypedKeyFromParts({
					id: "UnitsPerSize",
				}));
			}
		},

		/**
		 * @override
		 * Set appropriate relationship for view based on root node
		 */
		_preView() {
			this.relRoot = this.defView.m_relationships[0] = this.isPO() ? this._poRelationship : this._productRelationship;
			this.inherited(arguments);
		},

		/**
		 * Manage two relationships in view, which only displays one at a time
		 */
		_resolveView: function() {
			var rc = reflection.getClass("PurchasedOrderProduct");
			var rels = this.defView.m_relationships;
			var node = this.getViewNode();
			var poProduct;

			if (node) {
				if (node.$Type == "PurchasedOrderProduct") {
					// this is possible when printing view, so temporarily switch back PO as root node to resolve the view
					poProduct = node;
					this._urlPO = node.__Parent__;
					this.setViewNode(this.getPO());
				} else {
					this._urlPO = this.urlRoot;
				}
			}

			this._poRelationship = rels[0];
			this._productRelationship = rels.pop();
			this._productRelationship.key = 0;

			this.inherited(arguments);

			// make sure to do this second so defView.m_rcRoot is set correctly
			this._productRelationship.resolve(this.defView.getLocaleMap(rc), rc);

			// if root was initially a PO product, then switch back to that
			if (poProduct) {
				this.setViewNode(poProduct);
			}
		}
	});
});